import "./JapaneseLanguageSupport.module.css";
import PracticeAreasOverview from "./sections/PracticeAreasOverview";
import ContactInquiryCta from "./sections/ContactInquiryCta";
import Japanesesupportoverview from "./sections/Japanesesupportoverview";
import Japanesecommunityreferral from "./sections/Japanesecommunityreferral";
import Consultationpreparationchecklist from "./sections/Consultationpreparationchecklist";
import Staff from "./sections/Staff";
import Footer from "@/reusable_sections/Footer";
import Mainheader from "./sections/Mainheader";
export default function JapaneseLanguageSupportPage() {
  return <div>
      <Mainheader />
      <PracticeAreasOverview />
      <Japanesesupportoverview />
      <ContactInquiryCta />
      <Japanesecommunityreferral />
      <Consultationpreparationchecklist />
      <Staff />
      <Footer />
    </div>;
}